module.exports = __webpack_public_path__ + "1235e0002302366ce1ba173db9b40978.pdf";